<template>
    <v-layout>
        <v-flex xs12>
            <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            <v-card v-if="!loading">
                <v-card-title class="headline primary white--text">
                    {{ 'Equipment Health Overview'|translate }}
                </v-card-title>

                <v-layout row wrap>
                    <v-flex xs1>
                        <value-box
                            :value="items.length"
                            icon=""
                            use-int
                            :title="'Total'|translate">
                        </value-box>
                    </v-flex><v-flex xs1>
                        <value-box
                            :value="criticalNotifCount"
                            icon=""
                            use-int
                            :title="'Critical'|translate">
                        </value-box>
                    </v-flex><v-flex xs1>
                        <value-box
                            :value="highNotifCount"
                            icon=""
                            use-int
                            :title="'High'|translate">
                        </value-box>
                    </v-flex><v-flex xs1>
                        <value-box
                            :value="mediumNotifCount"
                            icon=""
                            use-int
                            :title="'Medium'|translate">
                        </value-box>
                    </v-flex><v-flex xs1>
                        <value-box
                            :value="lowNotifCount"
                            icon=""
                            use-int
                            :title="'Low'|translate">
                        </value-box>
                    </v-flex>
                    <span style="width:300px;">
                        <v-select
                            color="white"
                            :items="severities"
                            class="mx-4"
                            multiple
                            label="Show severity"
                            v-model="selectedSeverities">
                      </v-select>
                    </span>
                    <v-chip close v-if="floorFilter"
                            @input="floorFilter=null"
                            label
                    >
                        Floor : {{floorFilter}}
                    </v-chip>
                    <v-chip close v-if="typeFilter"
                            @input="typeFilter=null"
                            label
                    >
                        Type : {{typeFilter}}
                    </v-chip>
                    <v-btn class="accent" @click="openBreakdown">{{ 'Go to breakdown'|translate }}</v-btn>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                </v-layout>
                <v-card-text>

                    <v-layout row wrap>
                    <v-flex xs4>
                        <vue-echart v-if="ecOption" :config="ecOption" :height="1000" @click="handleECClick"></vue-echart>
                    </v-flex>
                    <v-flex xs8>
                        <v-data-table
                            :headers="headers"
                            :items="refinedItems"
                            class="elevation-1"
                            disable-initial-sort
                            :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                            :items-per-page="25"
                            :search="search2"
                        >
                            <template v-slot:items="props">
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.title }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.equip }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" >{{ props.item.equipType }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" >{{ props.item.floor }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" v-if="!props.item.gauge">{{ props.item.value }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" v-if="props.item.gauge">
                                    <vue-plotly :data="props.item.gauge.data"  :layout="props.item.gauge.layout" :options="{displayModeBar: false}"/>
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" >{{ props.item.status }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning" @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey" @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                    <v-tooltip bottom v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <template v-slot:badge v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                    <span>{{props.item.maintenance_records.length}}</span>
                                                </template>
                                                <v-icon v-on="on" small class="ml-2 mr-1" >fa-clipboard-list</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{props.item.maintenance_records.length}} {{'Maintenance Records'|translate}} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" color="success" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{'Maintenance Completed'|translate}} </span>
                                    </v-tooltip>
                                </td>
                            </template>
                            <template v-slot:no-data>
                            </template>
                        </v-data-table>
                    </v-flex>
                    </v-layout>
                    <v-dialog fullscreen v-model="dialog">
                        <equipment-health v-if="dialog&&selectedEquipment" embedded-mode :equipment-name-preset="selectedEquipment"></equipment-health>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="dialog=false">{{ 'Close'|translate }}</v-btn>
                        </v-card-actions>
                    </v-dialog>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getNotification, getMaintenanceRecords, putNotification,getRule} from '../helper';
import EquipmentHealth from "@/views/EquipmentHealth";
import moment from "moment";
import VueEchart from "@/components/VueEchart";
import {sortFloors} from '@/helper'
import SeverityChip from "@/components/SeverityChip";
import VuePlotly from "@/components/VuePlotly";
import ValueBox from "../components/ValueBox";

export default {
    name: 'EquipmentHealthSummary',
    components: {EquipmentHealth, VueEchart, SeverityChip,VuePlotly,ValueBox},
    data() {
        return {
            severities:["critical","high","medium","low","info"],
            selectedSeverities:["critical","high","medium","low","info"],
            typeFilter:null,
            floorFilter:null,
            dialog: false,
            selectedEquipment: null,
            loading:true,
            config: [],
            dateRange: {
                start:moment().subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                end: moment().format('YYYY-MM-DD HH:mm:ss')
            },
            search: '',
            search2: '',
            items:[],
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    computed: {
        refinedItems(){
            let items = this.items.filter(x=>x.severity&&this.selectedSeverities.includes(x.severity))
            if (this.typeFilter){
                items=items.filter(x=>x.equipType===this.typeFilter)
            }
            if (this.floorFilter){
                items=items.filter(x=>x.floor===this.floorFilter)
            }
            return items
        },
        ecOption(){
            if(!this.refinedItems||this.refinedItems.length===0){
                return null
            }
            let floors=sortFloors([...new Set(this.refinedItems.map(x=>x.floor))])
            let types=[...new Set(this.refinedItems.map(x=>x.equipType))]
            let mapData=[]
            for (let findex in floors){
                for (let tindex in types){
                    let found=this.refinedItems.filter(x=>x.floor===floors[parseInt(findex)]&&x.equipType===types[parseInt(tindex)]).length
                    found = found > 0 ? found : "-"
                    mapData.push([parseInt(tindex),parseInt(findex),found])
                }
            }
            return {
                tooltip: {
                    position: 'top'
                },
                grid: {
                    height: '75%',
                    top: '7%',
                    left: '20%',
                    backgroundColor: "rgba(0,0,0,0)"
                },
                xAxis: {
                    type: 'category',
                    triggerEvent: true,
                    data: types,
                    splitArea: {
                        show: true
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 45
                    }
                },
                yAxis: {
                    type: 'category',
                    triggerEvent: true,
                    data: floors,
                    splitArea: {
                        show: true
                    },
                    axisLabel: {
                        interval: 0,
                    }
                },
                visualMap: {
                    min: 0,
                    max: Math.max(...mapData.filter(x=>x[2]!=="-").map(x=>x[2])),
                    calculable: true,
                    orient: 'horizontal',
                    left: 'center',
                    top: '0',
                    textStyle: this.unifiedIsThemeDark ? {color: "rgba(255, 255, 255, 1)" } : null,
                },
                series: [
                    {
                        name: 'Notifications',
                        type: 'heatmap',
                        data: mapData,
                        label: {
                            show: true
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
        },
        headers() {
            return [
                {
                    text: this.$options.filters.translate('Issue'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                {text: this.$options.filters.translate('Equipment'), value: 'equip'},
                {text: this.$options.filters.translate('Equipment Type'), value: 'equipType',sortable: true},
                {text: this.$options.filters.translate('Floor'), value: 'floor',sortable: true},
                {text: this.$options.filters.translate('Value'), value: 'value'},
                {text: this.$options.filters.translate('Status'), value: 'status'},
                {text: this.$options.filters.translate('Severity'), value: 'severity'},
                {text: this.$options.filters.translate('Acknowledged'), value: 'acknowledged'},
            ]
        },
        highNotifCount(){
            return this.items.filter(x=>x.severity==="high").length
        },
        criticalNotifCount(){
            return this.items.filter(x=>x.severity==="critical").length
        },
        mediumNotifCount(){
            return this.items.filter(x=>x.severity==="medium").length
        },
        lowNotifCount(){
            return this.items.filter(x=>x.severity==="low").length
        },
    },
    methods: {
        handleECClick(data){
            if (data&&data.componentType){
                if (data.componentType==="xAxis"){
                    if (this.typeFilter){
                        this.typeFilter=null
                    } else {
                        this.typeFilter=data.value
                    }
                } else if (data.componentType==="yAxis"){
                    if (this.floorFilter){
                        this.floorFilter=null
                    } else {
                        this.floorFilter=data.value
                    }
                }
            }
        },
        initialize() {
            this.refresh()
        },
        callDialog(item) {
            this.selectedEquipment=item.equip
            this.dialog=true
        },
        async trigger(id, state) {
            await putNotification(
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'notification_id': id,
                    'show_flag': state
                }
            )
        },

        async refresh() {
            this.loading=true
            let rawMRs= await  getMaintenanceRecords({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                date_range:this.dateRange
            })
            let notifsResult = await getNotification({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                ignore_acknowledged:true,
                date_range:[this.dateRange.start,this.dateRange.end],
            })
            let ruleDf = await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            let applicableRules=ruleDf.result.filter(x=>x.active_status==="active"&&x.topic==="equipment health")

            let filteredNotifs=notifsResult.result.filter(function(x) {
                return !x.acknowledged&&x.topic==="equipment health" })
            let items = []
            for (let notif of filteredNotifs) {
                let refinedNotif={
                    icon: 'fa-bell',
                    alertType: notif['model'],
                    title: notif['title'],
                    equip: notif['equipment_name'],
                    equipType: notif['equipment_type'],
                    floor: notif['floor'],
                    startDate: notif['start_date'],
                    endDate: notif['end_date'],
                    topic: notif['topic'],
                    occurredTimes: notif['occurred_times'],
                    to: notif['to'],
                    description: notif['description'],
                    recommendedActions: notif['recommended_actions'],
                    severity: notif['severity'],
                    value: notif['value'],
                    status: "",
                    gauge: null,
                    accumulated_cost: notif['accumulated_cost'],
                    notification_id: notif.notification_id,
                    acknowledged: notif['acknowledged'],
                    maintenance_records:rawMRs.result.filter(x=>x.notification_id&&x.notification_id===notif.notification_id)
                }
                let rule=applicableRules.filter(x=>x.title===refinedNotif.title&& (x.equipment_group == null || (typeof x.equipment_group === "string" && x.equipment_group.trim() === "")  ||x.equipment_group===refinedNotif.equipType))[0]
                if(rule){
                    refinedNotif.value=refinedNotif.value ? refinedNotif.value : rule.meta.kpiThresholds[0].range[0]
                    let foundThresh=rule.meta.kpiThresholds.filter(x=>refinedNotif.value>=x.range[0]).reverse()[0]
                    refinedNotif.status = foundThresh ? foundThresh.status : ""
                    refinedNotif.gauge={
                        data:[
                            {
                                type: "indicator",
                                mode: "gauge+number",
                                value: refinedNotif.value,
                                gauge: {
                                    bar: { color: "white" },
                                    axis: { range: [rule.meta.kpiThresholds[0].range[0],rule.meta.kpiThresholds[rule.meta.kpiThresholds.length-1].range[1]] },
                                    bordercolor: "white",
                                    steps: rule.meta.kpiThresholds,
                                    shape: "bullet"
                                }
                            }
                        ],
                        layout:{
                            height: 45,
                            width:300,
                            margin:{
                                l: 20,
                                r: 0,
                                t: 0,
                                b: 25,
                                pad: 1
                            },
                        },

                    }

                }
                items.push(refinedNotif)
            }

            this.items=items
            this.loading=false

        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        openBreakdown(){
            let output = {
                path: '/notification-breakdown',
                query:{
                    rangeStart: this.dateRange.start,
                    rangeEnd: this.dateRange.end,
                    topic:"equipment health"
                }
            }
            if (this.typeFilter){
                output.query.equipment_type=this.typeFilter
            }
            if (this.floorFilter){
                output.query.floor=this.floorFilter
            }
            if (this.selectedSeverities&&this.selectedSeverities.length===1){
                output.query.severity = this.selectedSeverities[0]
            }
            this.$router.push(output)
        },
    },
    async beforeMount(){
        let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
        let rangeStart = _.get(this.$route.query, 'rangeStart', null)
        let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
        if (!!rangeStart) {
            this.dateRange = {start: rangeStart, end: rangeEnd}
        } else if(maxDate){
            this.dateRange={
                start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
            }
        }
    },
}
</script>

<style scoped>

</style>
